const Layout = ({ children, menu }) => {
  return <>{children}</>;
};

export default Layout;
